import TextEditor, { ITextEditorProps } from './TextEditor';

export default TextEditor;
export type { ITextEditorProps };
